import { Stack, useTheme } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { TodayPrice } from "src/assets";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import ProgressBarTitle from "src/components/Displays/ProgressBarTitle";

const ModalContent = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Stack gap={4}>
      <ProgressBarTitle
        color={theme.palette.grey[500]}
        text={t("page.tariff.modal.content1")}
      />

      <Stack gap={4}>
        <TodayPrice />
        <PageSubTitle
          color={theme.palette.grey[400]}
          text={t("page.tariff.modal.subtitle")}
        />
      </Stack>

      <ProgressBarTitle
        color={theme.palette.grey[500]}
        text={
          <Trans
            i18nKey={
              t("page.tariff.modal.content2") as "page.tariff.modal.content2"
            }
            t={t}
            components={{
              linkTag: (
                <Link
                  to="https://epexspot.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        }
      />
    </Stack>
  );
};

export default ModalContent;
